import React from 'react';

export default {
  width: 11,
  height: 13,
  content: <path d="M.959.564l9.378 5.741-9.378 5.741V.564z" />
};
